/**
 * Kompakt (mobil) layout bruges på smalle skærme og på liggende telefoner, hvor højden er det knappe mål:
 * 844x390 ville ellers få desktop-layoutet med en sidetitel, der æder det meste af kortet.
 */
export const MOBILE_BREAKPOINT = 768;
export const LANDSCAPE_PHONE_MAX_HEIGHT = 500;
export const LANDSCAPE_PHONE_MAX_WIDTH = 1000;

export function isCompactViewport(
  width: number,
  height: number,
  breakpoint = MOBILE_BREAKPOINT,
): boolean {
  if (width < breakpoint) return true;
  return height <= LANDSCAPE_PHONE_MAX_HEIGHT && width <= LANDSCAPE_PHONE_MAX_WIDTH;
}
